import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {
  collection,
  collectionSnapshots,
  Firestore,
} from '@angular/fire/firestore';
import { map } from 'rxjs/operators';

@Injectable()
export class CommonService {
  constructor() {}

  private firestore = inject(Firestore);
  private destroyRef = inject(DestroyRef);

  getCommons() {
    return collectionSnapshots(collection(this.firestore, `common`)).pipe(
      takeUntilDestroyed(this.destroyRef),
      map((actions) => {
        return actions.map((a) => {
          const data = a.data() as any;
          const id = a.id;
          return { id, ...data };
        });
      })
    );
  }
}
